<template>
  <div>
    <h4 class="text-base font-medium block mb-2.5">
      {{ $t("artwork_details.palette") }}
    </h4>
    <div class="flex flex-wrap gap-1">
      <div
        v-for="(color, i) in colorPalette"
        :key="i"
        class="h-5 w-12 rounded transition-transform cursor-crosshair"
        :style="{
          backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b})`,
        }"
        :title="`RGB(${color.r}, ${color.g}, ${color.b})`"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ColorPalette } from "~~/types/artwork";
defineProps<{
  colorPalette: ColorPalette[];
}>();
</script>
